import type { SurveyType } from '../../../shared/constants';

// Route state another page can pass when it navigates to /v2/patients/:id so
// the page opens on a given tab (and the Insights tab on a given survey type)
// instead of Overview. The location Insights tab's lowest-score list uses it
// to land on that patient's insights for the same survey.
export type PatientDetailsLocationState = {
  // A tab label from PatientDetails' tabConfig; ignored when the viewer's
  // role cannot see that tab.
  tab?: string;
  surveyType?: SurveyType;
};

export const PATIENT_INSIGHTS_TAB = 'Insights';

export const patientDetailsPath = (customerId: number): string =>
  `/v2/patients/${customerId}`;

// Reads the state off a router location without trusting its shape.
export const readPatientDetailsState = (
  state: unknown,
): PatientDetailsLocationState => {
  if (!state || typeof state !== 'object') return {};
  const { tab, surveyType } = state as Record<string, unknown>;
  return {
    tab: typeof tab === 'string' ? tab : undefined,
    surveyType:
      typeof surveyType === 'number' ? (surveyType as SurveyType) : undefined,
  };
};
